import gql from 'graphql-tag';

export const ME_QUERY =
gql`
    query {
        me {
            user_id
            name
            account
        }
    }
`;
